import { HttpService } from "../../modules/shared/services/http.service";
import { 
  QuoteFormSettings, 
  QuoteFormSettingsCreateDto, 
  QuoteFormSettingsUpdateDto, 
  QuoteFormSettingsResponse, 
  QuoteFormSettingsFilters, 
  QuoteFormSettingsSort 
} from "../../modules/shared/model/quoteFormSettings.interfaces";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

/**
 * Quote Form Settings API Actions
 * All API calls for quote form settings management using HttpService
 */

export const createQuoteFormSettings = async (data: QuoteFormSettingsCreateDto): Promise<QuoteFormSettings> => {
  const response = await HttpService.post("api/v1/quote-form-settings", data, headers, true);
  return response;
};

export const updateQuoteFormSettings = async (id: string, data: QuoteFormSettingsUpdateDto): Promise<QuoteFormSettings> => {
  const response = await HttpService.patch(`api/v1/quote-form-settings/${id}`, data, headers, true);
  return response;
};

export const getQuoteFormSettingsById = async (id: string): Promise<QuoteFormSettings> => {
  const response = await HttpService.get(`api/v1/quote-form-settings/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

export const getQuoteFormSettings = async (query?: Record<string, string | number | boolean>): Promise<QuoteFormSettingsResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/quote-form-settings${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

export const deleteQuoteFormSettings = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/quote-form-settings/${id}`, { "x-custom-lang": "en" }, true);
};

export const getQuoteFormSettingsWithFilters = async (
  filters?: QuoteFormSettingsFilters, 
  sort?: QuoteFormSettingsSort[], 
  page?: number, 
  limit?: number
): Promise<QuoteFormSettingsResponse> => {
  const query: Record<string, string | number | boolean> = {};
  
  if (filters) {
    // Add any specific filters if needed in the future
    // For now, we'll use generic filters
  }
  
  if (sort && sort.length > 0) {
    query.sort = JSON.stringify(sort);
  }
  
  if (page) query.page = page;
  if (limit) query.limit = limit;
  
  return getQuoteFormSettings(query);
};
